var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: "43.349mm",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 4335 4335",
    width: "43.349mm",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_601124728"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4081 2443-630-928 630-929h-1259v1857z",
    fill: "#c62223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m518 206h2700v1857h-2700z",
    fill: "#e31e24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2827 2063h391l-391 390z",
    fill: "#a32421"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m412 83h213v4201h-213z",
    fill: "#c5c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305 4162h426v122h-426z",
    fill: "#b2b3b3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m412 83h213v4201h-213z",
    fill: "#c5c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305 83h426v122h-426z",
    fill: "#b2b3b3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m305 4162h426v122h-426z",
    fill: "#b2b3b3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.ebafc821bb533181bfbed09cd059c4eb.svg";
export { ForwardRef as ReactComponent };